import { useState } from 'react';
import { C, S } from '../constants';
import { fmt, exportXlsx } from '../utils';
import Img from '../components/Img';
import ProdLink from '../components/ProdLink';
import InfoTip from '../components/InfoTip';
import { Badge } from '../components/badges';

export default function TrendingPage({ trend = [], revivedStock = [] }) {
  const [filter, setFilter] = useState("all");

  const growing = trend.filter(p => !p.was_revived);
  const visible = filter === "growing" ? growing : trend;

  return (
    <div>
      {/* ── Під наглядом ── */}
      {revivedStock.length > 0 && (
        <div style={{ ...S.card, marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
            <span style={{ fontSize: 20 }}>👁</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700 }}>Під наглядом</div>
              <div style={{ fontSize: 11, color: C.text4, marginTop: 1 }}>
                вийшли з мертвого запасу · моніторинг 7 днів · {revivedStock.length} товарів
              </div>
            </div>
            <div onClick={() => {
              const rows = [["ID", "Назва", "Артикул", "Днів після ожиття", "Мертвий днів", "Продажі 7д", "Залишок", "FF?", "Стан"]];
              revivedStock.forEach(p => {
                const isStalling = p.daily_sales.slice(-2).every(v => v === 0);
                rows.push([p.product_id, p.name || "", p.article || "", p.days_since_revival, p.gap_days, p.recent_qty, p.is_ff ? p.ff_stock : p.fbs_stock, p.is_ff ? "FF" : "FBS", isStalling ? "Зупинився" : "Активний"]);
              });
              exportXlsx([{ name: "Під наглядом", rows }], "під_наглядом.xlsx");
            }} style={{
              padding: "5px 12px", borderRadius: 8, fontSize: 12, fontWeight: 600,
              cursor: "pointer", userSelect: "none", flexShrink: 0,
              background: `${C.green}18`, color: C.green,
              border: `1px solid ${C.green}40`,
            }}>
              ↓ Excel
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {revivedStock.map((p, i) => {
              const isStalling = p.daily_sales.slice(-2).every(v => v === 0);
              const stock = p.is_ff ? p.ff_stock : p.fbs_stock;
              const stockOk = stock >= 3;
              const color = isStalling ? C.pink : C.blue;
              const maxBar = Math.max(...p.daily_sales, 1);
              return (
                <div key={i} style={{
                  display: "flex", alignItems: "center", gap: 10,
                  padding: "8px 10px", borderRadius: 8,
                  background: `${color}08`,
                  border: `1px solid ${color}25`,
                  borderLeft: `3px solid ${color}`,
                }}>
                  <Img src={p.image_url} size={32} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <ProdLink name={p.name} article={p.article} productId={p.product_id}
                      style={{ fontSize: 11, display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} />
                    <div style={{ fontSize: 10, color: C.text4, marginTop: 2 }}>
                      {isStalling
                        ? <span style={{ color: C.pink, fontWeight: 600 }}>⚠ Знову зупинився</span>
                        : <span style={{ color, fontWeight: 600 }}>{p.days_since_revival === 0 ? "ожило сьогодні" : `ожило ${p.days_since_revival} дн. тому`}</span>
                      }
                      <span style={{ marginLeft: 6 }}>· мертвий {p.gap_days} дн. · {p.recent_qty} шт.</span>
                    </div>
                  </div>
                  {/* 7-day sparkline */}
                  <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height: 24, flexShrink: 0 }}>
                    {p.daily_sales.map((v, di) => (
                      <div key={di} style={{
                        width: 8, flexShrink: 0,
                        background: v > 0 ? color : `${color}20`,
                        height: v > 0 ? Math.max(3, Math.round(v / maxBar * 20)) : 2,
                        borderRadius: "1px 1px 0 0",
                        alignSelf: "flex-end",
                      }} title={`${v} шт.`} />
                    ))}
                  </div>
                  {/* Stock */}
                  <div style={{ fontSize: 10, color: stockOk ? C.green : C.pink, fontWeight: 700, flexShrink: 0, minWidth: 50, textAlign: "right" }}>
                    {p.is_ff ? "FF" : "FBS"} {stock}{!stockOk ? " ⚠" : ""}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Зростаючі продажі ── */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ fontSize: 20, fontWeight: 800 }}>Зростання продажів</div>
        <InfoTip text={"Порівняння останніх 14 днів з попередніми 14 днями.\n\n📈 Зростання — продажі збільшились на 50%+\n\nСамозакупи (викупи) не враховуються.\nМінімум 3 шт. за 14 днів."} />
        <span style={{ fontSize: 12, color: C.text3 }}>{fmt(growing.length)} товарів</span>
        <div onClick={() => {
          const sheets = [];
          if (visible.length) {
            const rows = [["ID", "Назва", "Артикул", "Категорія", "Попередні 14д", "Поточні 14д", "Зростання %"]];
            visible.forEach(p => rows.push([p.product_id, p.name || "", p.article || "", p.category_name || "", p.prev_week_qty, p.curr_week_qty, p.growth_pct]));
            sheets.push({ name: "Зростання", rows });
          }
          if (revivedStock.length) {
            const rows = [["ID", "Назва", "Артикул", "Днів після ожиття", "Мертвий днів", "Продажі 7д", "Залишок", "FF?"]];
            revivedStock.forEach(p => rows.push([p.product_id, p.name || "", p.article || "", p.days_since_revival, p.gap_days, p.recent_qty, p.is_ff ? p.ff_stock : p.fbs_stock, p.is_ff ? "FF" : "FBS"]));
            sheets.push({ name: "Під наглядом", rows });
          }
          if (sheets.length) exportXlsx(sheets, "зростання.xlsx");
        }} style={{
          marginLeft: "auto", padding: "5px 12px", borderRadius: 8, fontSize: 12, fontWeight: 600,
          cursor: "pointer", userSelect: "none",
          background: `${C.green}18`, color: C.green,
          border: `1px solid ${C.green}40`,
        }}>
          ↓ Excel
        </div>
      </div>

      {/* Filter tabs */}
      <div style={{ display: "flex", gap: 2, background: C.bg1, padding: 3, borderRadius: 11, border: `1px solid ${C.border}`, width: "fit-content", marginBottom: 16 }}>
        {[
          ["Всі", "all", trend.length],
          ["📈 Зростання", "growing", growing.length],
        ].map(([l, v, cnt]) => (
          <div key={v} onClick={() => setFilter(v)} style={{
            padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600,
            cursor: "pointer", userSelect: "none", transition: "all .12s",
            background: filter === v ? `${C.blue}22` : "transparent",
            color: filter === v ? C.blue : C.text3,
          }}>{l} {cnt > 0 && <span style={{ fontSize: 11, opacity: 0.7 }}>({cnt})</span>}</div>
        ))}
      </div>

      {visible.length === 0
        ? <div style={{ color: C.text3, padding: 40, textAlign: "center" }}>Немає товарів</div>
        : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 10 }}>
            {visible.map(p => {
              const hasBulk = p.bulk_max_qty >= 3 && p.bulk_max_qty >= p.curr_week_qty * 0.5;
              const borderColor = hasBulk || p.fake_qty_curr > 0 ? `${C.yellow}44` : C.border;
              return (
                <div key={p.product_id} style={{
                  ...S.card, padding: 12, display: "flex", gap: 10, alignItems: "center",
                  border: `1px solid ${borderColor}`,
                }}>
                  <Img src={p.image_url} size={40} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <ProdLink name={p.name} article={p.article} productId={p.product_id} style={{ fontSize: 12 }} />
                    <div style={{ fontSize: 11, color: C.text3, marginTop: 3 }}>
                      <span>{p.prev_week_qty} → {p.curr_week_qty} шт за 14 днів</span>
                      {p.fake_qty_curr > 0 && <span style={{ color: C.yellow }}> · ⚠ {p.fake_qty_curr} викупів</span>}
                      {hasBulk && <span style={{ color: C.yellow }}> · ⚠ опт {p.bulk_max_qty}шт</span>}
                    </div>
                    <div style={{ fontSize: 11, color: C.text4, marginTop: 2 }}>{p.category_name}</div>
                  </div>
                  <Badge color={C.green}>+{p.growth_pct}%</Badge>
                </div>
              );
            })}
          </div>
        )
      }
    </div>
  );
}
